import React from 'react'
import parse from 'html-react-parser'

import Link from '../utils/link'

import { Play, YouTube, Instagram, WeChat, Facebook, LinkedIn } from '../components/icons'
import FsLightbox from 'fslightbox-react'


const AgentProfileHeroBanner = ({ location, team, isTeam, wpAgent }) => {

  const [videoLightbox, setVideoLightbox] = React.useState(false)

  let { stats, socialMediaAccounts, video } = team.acf

  const color = '#FFFFFF'

  const splitString = (string) => {
    return string.split(' ').join('<br />')
  }

  if (video) {
    video = `https://www.youtube.com/watch?v=${video.split('.be/')[1]}`
  }

  return (
    <>
      <section className='profile__hero-banner'>

        <div className='profile__inner'>

          <div className='profile__header'>

            <div className='profile__details'>

              <div className='profile__heading'>
                { !isTeam && <h2 className='heading'>{team.teamDetails.firstName}<br />{team.teamDetails.lastName}</h2> }
                { isTeam && <h2 className='heading'>{parse(splitString(wpAgent.title))}</h2> }
              </div>

              <div className='profile__position'>
                <p className='job-title'>{isTeam ? wpAgent.acf.jobTitle : team.teamDetails.jobTitle}</p>
                { team.acf.companyName ? 
                  <p className='company-name'>{team.acf.companyName}</p> :
                  <p className='location'>{location}</p> 
                }
              </div>

              {team.acf.link &&
                <div className='profile__link'>
                  <Link to={team.acf.link}>{team.acf.text}</Link>
                </div>
              }

            </div>

            <div className='profile__contact-details'>

              <div className='connect'>

                { !isTeam &&
                <>
                  {(team.acf.contactNumber || team.teamDetails.mobile) &&
                    <p><Link to={`tel:${team.acf.contactNumber ? team.acf.contactNumber : team.teamDetails.mobile}`}>{team.acf.contactNumber ? team.acf.contactNumber : team.teamDetails.mobile}</Link> </p>
                  }
                  {team.teamDetails.phone &&
                    <p><Link to={`tel:${team.teamDetails.phone}`}>{team.teamDetails.phone}</Link></p>
                  }
                  {team.teamDetails.email &&
                    <p className='email'><Link to={`mailto:${team.teamDetails.email}`}>Email {team.teamDetails.firstName}</Link></p>
                  }
                  {team.acf.vcard?.publicUrl &&
                    <p className='vcard'><a href={team.acf.vcard?.publicUrl} target='_blank' rel='noopener noreferrer' download>Download vCard</a></p>
                  }
                </>
                }
                { isTeam &&
                  <>
                    {wpAgent.acf?.phone?.url &&
                      <p><Link to={wpAgent.acf.phone.url}>{wpAgent.acf.phone.title}</Link></p>
                    }
                    {wpAgent.acf?.email?.url &&
                      <p className='email'><Link to={wpAgent.acf.email.url}>{wpAgent.acf.email.title}</Link></p>
                    }
                  </>
                }

                {socialMediaAccounts?.length &&
                  <div className='profile__connect'>
                    <div className='social-icons'>
                      <ul>
                        {socialMediaAccounts.map((el, i) => (
                          <li className={el.account === 'linkedin' ? 'linkedin' : ''} key={i}>
                            <Link to={el.link}>
                              {el.account === 'linkedin' && <LinkedIn color={color} />}
                              {el.account === 'facebook' && <Facebook color={color} />}
                              {el.account === 'instagram' && <Instagram color={color} />}
                              {el.account === 'wechat' && <WeChat color={color} />}
                              {el.account === 'youtube' && <YouTube color={color} />}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                }

              </div>

            </div>

            <div className='profile__image'>
              <img src={isTeam ? wpAgent.acf.profileImage?.sourceUrl : team.acf.profileImage?.sourceUrl} alt={team.title} />
              <div className='profile__connect-video'>
                {video && !wpAgent.acf.hideVideo &&
                  <button
                    className='profile__video'
                    type='button'
                    onClick={() => setVideoLightbox( !videoLightbox )}
                  >
                    <Play color='#FFFFFF' /> Bio Video
                  </button>
                }
              </div>
            </div>

          </div>

        </div>

        <div className='profile__social'>

          <div className='profile__inner'>

            <div className='profile__bio-stats'>
              { !isTeam &&
                <div className="profile__stats">
                  {stats?.map((el, i) => (
                    <div className='profile__stat' key={i}>
                      <p className='value'>{el.value}</p>
                      <p className='label' dangerouslySetInnerHTML={{ __html: el.label }} />
                    </div>
                  ))}
                </div>
              }
              { isTeam &&
                <div className="profile__stats">
                  {wpAgent.acf.stats?.map((el, i) => (
                    <div className='profile__stat' key={i}>
                      <p className='value'>{el.title}</p>
                      <p className='label' dangerouslySetInnerHTML={{ __html: el.content }} />
                    </div>
                  ))}
                </div>
              }
              { team.acf?.disclaimer && 
                <div className='profile__disclaimer'>
                  <div dangerouslySetInnerHTML={{ __html: team.acf.disclaimer }} />
                </div>
              }
            </div>

          </div>

        </div>

      </section>

      {video && !wpAgent.acf.hideVideo &&
        <FsLightbox
          toggler={videoLightbox}
          sources={[
            video
          ]}
        />
      }
    </>
  )
}

AgentProfileHeroBanner.defaultProps = {
  team: null,
  location: '',
}

export default AgentProfileHeroBanner